import type { KnowledgeEdge, KnowledgeEntity } from '@/entities/knowledge';
import { KnowledgeEntityDetails } from '@/entities/knowledge';
import { ScrollArea } from '@/shared/ui/shadcn/scroll-area';

export function KnowledgeDetailsPanel({
  entity,
  edges,
}: {
  entity: KnowledgeEntity | null;
  edges: KnowledgeEdge[];
}) {
  return (
    <ScrollArea className="h-full">
      <KnowledgeEntityDetails entity={entity} edges={edges} className="h-full" />
    </ScrollArea>
  );
}
